import styled from 'styled-components/macro';
import { space, compose } from 'styled-system';

export default styled.div<any>`
  ${compose(space)}
  display: flex;
  flex-flow: row wrap;
  ${({ height }): string => (height ? `height: ${height};` : '')}
  ${({ alignCenteredVertically }): string =>
    alignCenteredVertically ? `align-items: center;` : ''}

  > * {
    flex-basis: 100%;
    margin: 0.25rem 0;
  }

  @media screen and (min-width: 50em) {
    gap: ${({ isSmallScreen }): string => (isSmallScreen ? '5px' : '10px')};

    > * {
      flex: 0 1 auto;
    }

    > label {
      max-width: 15em;
    }

    [data-menu-root] {
      margin-left: 0.25rem;
    }
  }
`;
